export default function BlockImageCabecera({ src, tag, title }) {
  return (
    <section className="relative w-full h-[320px]  h-[570px] overflow-hidden">
      {/* Imagen de fondo */}
      <img
        src={src}
        alt="cabecera"
        className="absolute inset-0 w-full h-full object-cover object-right lg:object-center"
      />

      {/* Capa de degradado */}
      <div
        className="absolute inset-0 z-10 
                   bg-gradient-to-t from-[#004270]/90 via-[#004270]/40 to-transparent
                   lg:w-1/2 lg:bg-gradient-to-r lg:from-[#004270]/85 lg:via-[#004270]/70 lg:to-[#004270]/30"
      >
        {/* Contenedor del contenido */}
        <div className="relative z-20 flex flex-col justify-end lg:justify-center items-center lg:items-start h-full px-6 pb-8 lg:pb-0 lg:pl-[13%] lg:pr-[10%] text-center lg:text-left">
          {/* Animación y contenido */}
          <div
            className=" 
           button-a 
           [&_h1]:text-white
          [&_h2]:text-white
          [&_p]:text-white
          [&_a]:mt-6 "
          >
            {/* Tag */}
            {tag && (
              <div className="flex items-center justify-center lg:justify-start gap-2 mb-2 text-xs sm:text-sm text-white/90">
                <span className="material-icons text-[14px]">circle</span>
                <span>{tag}</span>
              </div>
            )}

            {/* Título / Children libre de estilos forzados */}
            <div>{title}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
